import React from "react";
import Head from "@al/next/head";
// import Report from "~/common/reporter";

import Analytics from "~/common/tracker/analytics";
import unauthorizedToLogin from "~/common/utils/unauthorizedToLogin";

// 在业务站点扩展 pageConfig 功能，使其支持更多业务相关用法
// 注意，export 阶段不执行此文件，head 将不会附加到降级文件内
export function extendsPageConfig(pageConfig, Component) {
  return class SiteExtendsPageConfigPage extends React.PureComponent {
    constructor(props) {
      super(props);
      this.state = {
        pendingViaRedirect: false,
      };
      const { ctx } = props;
      //动态设置Report 用户uid
      const isSign = ctx.store.getState().sign.isSign;

      if (process.browser) {
        if (pageConfig.requireLogin) {
          if (!window.__NEXT_DATA__.requireLogin) window.__NEXT_DATA__.requireLogin = true;
        } else {
          if (window.__NEXT_DATA__.requireLogin) window.__NEXT_DATA__.requireLogin = false;
        }
      }

      if (isSign) {
        //有登陆态
        // Report.setUid(ctx.store.getState().sign.userDetail.uid);
        Analytics.setUid(ctx.store.getState().sign.userDetail.uid);
      } else {
        //登陆态缺失或失效
        // Report.setUid(null);
        Analytics.setUid("");
        // 未登录时，跳转到登录页
        unauthorizedToLogin(ctx);
      }
    }

    formatText(textOrFormat) {
      const { props } = this;
      const t =
        props.t ||
        (() => {
          throw new Error("该页面未指定 withI18n，无法使用 t()");
        });
      if (typeof textOrFormat === "function") {
        return textOrFormat(t);
      }
      if (typeof textOrFormat === "string") {
        return textOrFormat;
      }
      throw new Error(`预期外的参数 ${textOrFormat}`);
    }

    render() {
      const { props, state } = this;
      // const pagePath = props.ctx.router.asPath;
      return (
        <>
          {/* 注意，以下 meta ssr 时正常工作，但不会 export 到静态页中，只会动态注入 */}
          <Head>
            {"title" in pageConfig ? <title>{this.formatText(pageConfig.title) || ""}</title> : null}
            {"description" in pageConfig ? (
              <meta name="description" content={this.formatText(pageConfig.description) || ""} />
            ) : null}
            {/* 使用 .png，但根目录下存放 .ico，防止浏览器自动访问导致的 404 */}
            <link rel="shortcut icon" href="/mobile/silvrr/favicon.png" type="image/x-icon" />

            {/* web app */}
            <meta
              name="viewport"
              content="width=device-width, initial-scale=1.0, maximum-scale=1.0, user-scalable=no, viewport-fit=cover"
            />
            <meta name="mobile-web-app-capable" content="yes" />
            <meta name="apple-mobile-web-app-capable" content="yes" />
            <meta name="application-name" content="Akulaku" />
            <meta name="apple-mobile-web-app-title" content="Akulaku" />
            <meta name="theme-color" content="#ffffff" />
            {/**禁用电话号码识别 */}
            <meta name="format-detection" content="telephone=no" />
            {/* <script async defer crossOrigin="anonymous" src="https://connect.facebook.net/en_US/sdk.js"></script> */}
          </Head>
          {state.pendingViaRedirect ? null : <Component {...props} />}
        </>
      );
    }
  };
}
